<template>
  <slot />
</template>
<style>
@import "../assets/register/css/bootstrap.min.css";
@import "../assets/register/css/style.css";
@import "../assets/register/css/responsive.css";
</style>